<!-- 文件上传及转换的进度状态 -->
<template>
  <div class="doc-progress-status">
    <template v-if="docStatus === 'uploading'">
      <vh-progress :percentage="uploadPropress"></vh-progress>
    </template>
    <!-- 上传中有上传进度条，所以不用显示文字 -->
    <template v-if="docStatus !== 'uploading' && Array.isArray(docStatusStr)">
      <div
        v-for="(item, index) in docStatusStr"
        v-bind:key="'status' + index"
        class="transform-status"
        :class="
          docStatus == 'jpegtranscompleted' || docStatus == 'statustranscompleted'
            ? docStatus + index
            : docStatus
        "
      >
        {{ item }}
      </div>
    </template>
    <div v-else-if="docStatus !== 'uploading'" class="transform-status" :class="docStatus">
      {{ docStatusStr }}
    </div>
  </div>
</template>
<script>
  export default {
    name: 'DocProgressStatus',
    props: {
      // 文档转换状态
      // uploading: '上传中'
      // uploadfailed: '上传失败'
      // transwait: 等待转码 （上传成功后会转到此状态）
      // transdoing: 转码中
      // transcompleted: 转码成功
      // transfailed: 转码失败
      docStatus: {
        type: String,
        default: ''
      },
      // 上传进度
      uploadPropress: {
        type: Number,
        default: 0
      },
      // 文档转换进度
      transformProcess: {
        type: Number,
        default: 0
      },
      docExt: {
        type: String,
        default: ''
      },
      // 是否在资料库列表中使用
      isInDoclib: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      docStatusStr() {
        if (this.docStatus === 'uploading') {
          return this.$t('host.k_527001');
        } else if (this.docStatus === 'uploadfailed') {
          return this.$t('host.k_527002');
        } else if (this.docStatus === 'transwait') {
          return this.$t('host.k_527003');
        } else if (this.docStatus === 'transdoing') {
          return this.$t('host.k_527004');
        } else if (this.docStatus === 'jpegtranscompleted') {
          // if (this.isInDoclib && /pptx?/.test(this.docExt)) {
          //   return [this.$t('host.k_527005'), this.$t('host.k_527006')];
          // }
          // return this.isInDoclib ? this.$t('host.k_527007') : this.$t('host.k_527008');
          return this.$t('host.k_527007');
        } else if (this.docStatus === 'statustranscompleted') {
          // if (this.isInDoclib && /pptx?/.test(this.docExt)) {
          //   return [this.$t('host.k_527009'), this.$t('host.k_527010')];
          // }
          // return this.isInDoclib ? this.$t('host.k_527007') : this.$t('host.k_527008');
          return this.$t('host.k_527011');
        } else if (this.docStatus === 'transcompleted') {
          // if (this.isInDoclib && /pptx?/.test(this.docExt)) {
          //   return [this.$t('host.k_527005'), this.$t('host.k_527010')];
          // }
          // return this.isInDoclib ? this.$t('host.k_527007') : this.$t('host.k_527008');
          return this.$t('host.k_527007');
        } else if (this.docStatus === 'transfailed') {
          return this.$t('host.k_527011');
        } else return '';
      }
    }
  };
</script>
<style lang="less">
  .doc-progress-status {
    .transform-status {
      &::before {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 6px;
      }
      &.transcompleted:before {
        background-color: #14ba6a;
      }
      &.transfailed:before {
        background-color: red;
      }
      &.jpegtranscompleted0::before {
        background-color: #14ba6a;
      }
      &.jpegtranscompleted1:before {
        background-color: red;
      }
      &.statustranscompleted0:before {
        background-color: red;
      }
      &.statustranscompleted1:before {
        background-color: #14ba6a;
      }

      &.uploadfailed,
      &.transfailed {
        color: red;
      }
    }
  }
</style>
